module.exports = __webpack_public_path__ + "img/yatsuhashi tsukumo_lw.68c5dc58.png";